/** @format */

import React, { useContext } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  makeStyles,
  Modal,
  Fade,
  Backdrop,
  Button,
} from "@material-ui/core";
import UserContext from "../../context/Globales/UserContext";
import IcpdfDetalleEmpresa from "../pdf/IC/IcpdfDetalleEmpresa";

const useStyles = makeStyles((theme) => ({
  tituloTable: {
    backgroundColor: theme.palette.fondotitulos.main,
    // backgroundImage : `url(${FondoImagenes})`,

    minWidth: 200,
    color: "#171717",
    textAlign: "center",
    padding: "20px",
    fontWeight: "250",
    fontSize: "35px",
  },

  modalPdf: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  paperPdf: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "50%",
  },
}));

const TblDetalleEmpresa = (props) => {
  const classes = useStyles();
  const { datoIC } = useContext(UserContext);
  const [OpenModalpdfDetalle, setOpenModalpdfDetalle] = React.useState(false);
  const handleClickOpenModal = () => {
    setOpenModalpdfDetalle(!OpenModalpdfDetalle);
  };

  const TblIconoEmpresa = (
    <>
      <div
        style={{
          display: "flex",
          height: "100px",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre ==
        "MICRO" ? (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "140px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              MICRO EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/MicroEmpresaChekList.jpg"
              }
              style={{ width: "80%", textAlign: "center", padding: "5,10" }}
              alt="micro -empresa"
            />
          </div>
        ) : (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "140px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              MICRO EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/MicroEmpresa.jpg"
              }
              style={{ width: "60%", textAlign: "center", padding: "5,10" }}
              alt="micro -empresa"
            />
          </div>
        )}

        {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre ==
        "PEQUEÑA" ? (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "145px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              PEQUEÑA EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaPequenaChekList.jpg"
              }
              style={{ width: "90%", textAlign: "center", padding: "5,10" }}
              alt="pequeña -empresa"
            />
          </div>
        ) : (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "145px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              PEQUEÑA EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaPequena.jpg"
              }
              style={{ width: "60%", textAlign: "center", padding: "5,10" }}
              alt="pequeña -empresa"
            />
          </div>
        )}

        {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre ==
        "MEDIANA" ? (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "140px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              MEDIANA EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaMedianaChekList.jpg"
              }
              style={{ width: "90%", textAlign: "center", padding: "5,10" }}
              alt="mediana -empresa"
            />
          </div>
        ) : (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "140px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              MEDIANA EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaMediana.jpg"
              }
              style={{ width: "60%", textAlign: "center", padding: "5,10" }}
              alt="mediana -empresa"
            />
          </div>
        )}

        {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre ==
        "GRANDE" ? (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "142px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              GRANDE EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaGrandeChekList.jpg"
              }
              style={{ width: "90%", textAlign: "center", padding: "5,10" }}
              alt="grande -empresa"
            />
          </div>
        ) : (
          <div
            style={{
              color: "black",
              padding: "2,15",
              width: "142px",
              height: "70px",
              border: "1 solid #e6e6e6",
            }}
          >
            <span style={{ padding: "2,10", fontSize: 9, textAlign: "center" }}>
              GRANDE EMPRESA
            </span>
            <img
              src={
                process.env.PUBLIC_URL +
                "/static/imagen/IconoEmpresa/EmpresaGrande.jpg"
              }
              style={{ width: "60%", textAlign: "center", padding: "5,10" }}
              alt="grande -empresa"
            />
          </div>
        )}
      </div>
    </>
  );

  return (
    <>
      {/*MODAL PDF INFORME COMER*/}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modalPdf}
        open={OpenModalpdfDetalle}
        onClose={handleClickOpenModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}
      >
        <Fade in={OpenModalpdfDetalle}>
          <div className={classes.paperPdf}>
            <IcpdfDetalleEmpresa />
          </div>
        </Fade>
      </Modal>

      <div className={classes.tituloTable}>
        {datoIC.Identificacion?.IsEmpresa
          ? datoIC.DetalleIdentificacionEmpresa?.Nombre
          : datoIC.Identificacion?.Nombre}{" "}
        <br />
        {datoIC.Identificacion?.Rut}
    
        <br />
        {datoIC.DetalleIdentificacionEmpresa != null ? (
          <div style={{ alignContent: "center", textAlign: "center" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickOpenModal}
            >
              Descargar PDF
            </Button>
          </div>
        ) : (
          ""
        )}

      </div>

      {/*Empresa*/}
      <div className="container">

       
        {TblIconoEmpresa}
        <br />
        <p align="center" >
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Descripcion}
        </p>

        <br />
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Cantidad de Trabajadores: &nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.NumeroTrabajadores}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Tipo de Contribuyente: &nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.TipoContribuyente}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Sub Tipo de Contribuyente:&nbsp;</strong>
          {
            datoIC.DetalleIdentificacionEmpresa.DatosExtras
              ?.SubTipoContribuyente
          }{" "}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Rubro:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Rubro}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Sub Rubro:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.SubRubro}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Actividad:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Actividad}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Región:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Region}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Provincia:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Provincia}
        </Typography>
        <hr />
        <Typography variant="body2" align="justify">
          <strong>Comuna:&nbsp;</strong>
          {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Comuna}
        </Typography>
        <hr />
      </div>
    </>
  );
};

TblDetalleEmpresa.propTypes = {};

export default TblDetalleEmpresa;
